import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import ExportOrderForm from "./Order/Form";
import ExportRecList from "./RecList";


export default class OperationsExportOrder extends Component {
    constructor(props) {
        super(props);
        this.listRef = null;
        this.state = { add_export: false };
    }

    reloadList = () => {
        if(this.listRef)
            this.listRef.loadList();
    }

    render(){
        return <div>
            <ExportRecList 
                type="orders"
                ref={ref => {this.listRef = ref;}} 
                onAddClicked={() => this.setState({add_export: true})}
            />

            <Modal 
                isOpen={this.state.add_export} 
                toggle={() => this.setState({ add_export: false })}
                size="lg"
            >
                <ModalHeader toggle={() => this.setState({ add_export: false })}>Export des commandes</ModalHeader>
                <ModalBody>
                    <ExportOrderForm onCreateRec={this.reloadList} />
                </ModalBody>
            </Modal>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Operations/Export/Order.js